import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import React from "react"

const Two = ({ userType, termsChecked, handleTerms, classes }) => {
    return (
        <div>
            <div className={classes.bigContainer}>
                <Paper className={classes.paper}>
                    <div style={{ marginBottom: 24 }}>
                        <Typography
                            variant="subtitle1"
                            style={{ fontWeight: "bold" }}
                            gutterBottom
                        >
                            Termo de Permissão e Sigilo
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            Por favor, leia e caso concorde, aceite o Termo de Permissão e Sigilo
                        </Typography>
                    </div>
                    <div
                        style={{
                            height: 330,
                            padding: 16,
                            border: "2px solid #ccc",
                            borderRadius: "3px",
                            overflowY: "scroll"
                        }}
                    >
                        <Typography variant="body1" gutterBottom>
                            Para participação e submissão de trabalho na III Mostra Científica e Tecnológica da UFSC <i>campus</i> Curitibanos, através do ConTech,
                            essa plataforma manterá os dados dos participantes e apresentadores em sigilo, utilizando-os apenas no sistema para funcionamento do evento.
                        </Typography>
                    </div>
                    <FormGroup row>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={termsChecked}
                                    onChange={handleTerms}
                                    value="check"
                                />
                            }
                            label="Eu li e concordo com o Termo de Permissão e Sigilo"
                        />
                    </FormGroup>
                </Paper>
            </div>
        </div>
    );
}

export default Two;